import { Typography } from "@mui/material";
import React from "react";
import Card from "react-bootstrap/Card";

const WhatWeDo = () => {
  return (
    <Card>
      <Card.Header
        style={{
          fontFamily: "ToyotaType, sans-serif",
          fontStyle: "italic",
          color: "#626262",
        }}
      >
        What we do?
      </Card.Header>
      <Card.Body>
        <blockquote className="blockquote mb-0">
          <Typography
            variant="p"
            component="p"
            sx={{
              textDecoration: "none",
              textAlign: "justify",
              fontFamily: "ToyotaType, sans-serif",
              color: "#626262",
              fontWeight: "400",
            }}
          >
            Metrics to display both group and individual SFC balance sheets, as
            well as actual and forecasted income statements. This portal will
            also present key Treasury risk metrics along with their respective
            calculations. It will facilitate analytics that allow for the
            comparison of results between different scenarios across various
            databases. While access will be granted to users worldwide, the
            visibility of information will be regulated according to entitlement
            levels (RBAC).
          </Typography>
        </blockquote>
      </Card.Body>
      <Card.Footer
        style={{
          fontFamily: "ToyotaType, sans-serif",
          fontStyle: "italic",
          color: "#626262",
        }}
      >
        -Toyota Financial Services
      </Card.Footer>
    </Card>
  );
};

export default WhatWeDo;
